var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTagRibbon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 10 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 0v18l-5-5-5 5V0h10zM8.745 8.806l-2.579.548 1.746 1.972-1.526 1.13-1.358-2.28-1.358 2.28-1.555-1.13 1.72-1.917-2.58-.603.583-1.81L4.225 8.03 4.032 5.4h1.936l-.304 2.585 2.471-1.019.61 1.84z",
    fill: "current"
  })));
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iY3VycmVudCIgaGVpZ2h0PSJjdXJyZW50IiB2aWV3Qm94PSIwIDAgMTAgMTgiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xMCAwVjE4TDQuOTk5MzkgMTIuOTk5NUwwIDE4VjBIMTBaTTguNzQ1MTIgOC44MDU1MUw2LjE2NjM4IDkuMzUzNTJMNy45MTIxMSAxMS4zMjU4TDYuMzg1NzQgMTIuNDU2N0w1LjAyNzgzIDEwLjE3NjhMMy42NzAwNCAxMi40NTY3TDIuMTE0OTkgMTEuMzI1OEwzLjgzNTgyIDkuNDA5MDlMMS4yNTU4NiA4LjgwNTUxTDEuODM4MTMgNi45OTYwOEw0LjIyNDk4IDguMDMwMDRMNC4wMzE3NCA1LjM5OTlINS45NjgwMkw1LjY2MzcgNy45ODQ4TDguMTM1MzggNi45NjYzNUw4Ljc0NTEyIDguODA1NTFaIiBmaWxsPSJjdXJyZW50Ii8+Cjwvc3ZnPg==";
export { SvgTagRibbon as ReactComponent };